@file:Suppress("unused")

package kangaroorewards.js.appsdk

import kangaroorewards.appsdk.core.KangarooSdk

@OptIn(ExperimentalJsExport::class)
@JsExport
class KangarooSdk {
    fun initialize(
        appId: String,
        environment: String = "production",
        firebaseAppCheckToken: String,
        firebaseAuthToken : String
    ) {

        KangarooSdk().initialize(appId, environment, firebaseAppCheckToken, firebaseAuthToken)
    }

    /**
     * Sets a preferred language for the SDK
     *
     * @param preferredLanguage A language's ISO 639-1 code.
     */
    fun setPreferredLanguage(preferredLanguage: String) {
        KangarooSdk().setPreferredLanguage(preferredLanguage)
    }

    /**
     * Returns the preferred language setting for the SDK
     *
     * @return A language's ISO 639-1 code.
     */
    fun getPreferredLanguage(): String? {
        return KangarooSdk().getPreferredLanguage()
    }

    fun getSession(): String? {
        return KangarooSdk().getSession()
    }

    fun killSession() {
        KangarooSdk().killSession()
    }
}